import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { courtConnectBaseUrl } from "./connect-api";

export const agencyApi = createApi({
  reducerPath: "agencyApi",
  baseQuery: fetchBaseQuery({
    baseUrl: courtConnectBaseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("Access-Control-Allow-Methods", "GET,PUT,POST,DELETE,PATCH,OPTIONS");

      return headers;
    }
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (requestBody) => ({
        method: "POST",
        body: requestBody,
        url: "AllLogin"
      })
    }),
    register: builder.mutation({
      query: (requestBody) => ({
        method: "POST",
        body: requestBody,
        url: "AllPinRegister"
      })
    }),
    finalRegister: builder.mutation({
      query: (requestBody) => ({
        method: "POST",
        body: requestBody,
        url: "AllPinGenerate"
      })
    }),
    validateRecoverUser: builder.mutation({
      query: (requestBody) => ({
        method: "POST",
        body: requestBody,
        url: "AllPinQuestion"
      })
    }),
    resetPassword: builder.mutation({
      query: (requestBody) => ({
        method: "POST",
        body: requestBody,
        url: "AllPinChange"
      })
    })
  })
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useFinalRegisterMutation,
  useValidateRecoverUserMutation,
  useResetPasswordMutation
} = agencyApi;
